import { trackForm } from "./utils";
import { domReadyLegacy } from "../utils/ready";

interface Variables {
  timeout?: number;
}

function isContactPage() {
  return window.location.pathname.indexOf("/contact") === 0;
}

function isProductPage() {
  return !!document.querySelector("form[id^=form_] input[name=sku]");
}

export function install(vars: Variables, context: FeatureContext) {
  domReadyLegacy(() => {
    const trackVars = { ...vars, ...context };

    if (isContactPage()) {
      trackForm(
        "form[id^=form_][method=post]",
        "Website Contact Form Submitted",
        trackVars
      );
    } else if (isProductPage()) {
      trackForm(
        "form[id^=form_][method=post]",
        "Website Product Form Submitted",
        trackVars
      );
    }
  });
}
